import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import "../css/courses-view.css";
import CoursesChapter from "../Components/CoursesChapter";
import { API_BASE } from "../Utils/constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { retrieve, save } from "../helpers/StorageHelper";

export default function CoursesView() {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const chapterId = location.state?.chapterId;

  const [chapters, setChapters] = useState([]);
  const [moduleData, setModuleData] = useState({
    title: "",
    thumbnail: "",
    status: "",
    completion_percentage: 0,
  });
  const [videoCompletionStatus, setVideoCompletionStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeChapter, setActiveChapter] = useState(1);
  const [chapterLoading, setChapterLoading] = useState(false);



  const handleVideoComplete = (chapterNumber) => {
    setVideoCompletionStatus((prevState) => {
      const updatedState = {
        ...prevState,
        [chapterNumber]: true,
      };

      const completedCount = Object.values(updatedState).filter(Boolean).length;
      const newProgress = (completedCount / chapters.length) * 100;
      setModuleData((prev) => ({
        ...prev,
        completion_percentage: newProgress,
      }));

      return updatedState;
    });
  };

  const loadNextVideo = (chapterNumber) => {
    const nextChapter = chapterNumber + 1;
    if (nextChapter <= chapters.length) {
      setChapterLoading(true);
      setActiveChapter(nextChapter);
      setTimeout(() => {
        setChapterLoading(false);
        window.scrollTo(0, 0);
      }, 500);
    } else {
      const courseId = retrieve("courseId");
      navigate(`/courses/${courseId}/modules`, {
        state: {
          currentModuleId: moduleId,
          goToNext: true,
        },
      });
    }
  };

  const getActiveChapterNumber = (chapters, chapterId) => {
    if (!Array.isArray(chapters) || chapters.length === 0) return 1;

    const index = chapters.findIndex(
      (ch) => String(ch.id) === String(chapterId),
    );
    if (index !== -1) {
      return index + 1;
    }

    return 1;
  };

  useEffect(() => {
    const token = retrieve(AUTH_TOKEN);
    save("moduleId", moduleId); // Store moduleId in localStorage

    const fetchChapters = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/user/modules/${moduleId}/chapters`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = res.data?.data;
        setModuleData({
          title: data.module.title,
          thumbnail: data.module.thumbnail,
          status: data.module.status,
          completion_percentage: data.module.completion_percentage || 0,
        });
        setChapters(data.module.chapters);

        const initialStatus = {};
        data.module.chapters.forEach((ch, idx) => {
          initialStatus[idx + 1] = ch.status === "completed";
        });
        setVideoCompletionStatus(initialStatus);

        if (chapterId) {
          const active = getActiveChapterNumber(
            data.module.chapters,
            chapterId,
          );
          setActiveChapter(active);
        }
      } catch (error) {
        console.error("Error fetching module chapters", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChapters();
  }, [moduleId, chapterId]);

  return (
    <Layout>
      <div className="page-content">
        <div className="setting-content">
          <div
            className="d-flex align-items-center mb-md-4"
            style={{ gap: "12px" }}
          >
            <button
              onClick={() => navigate(-1)}
              className="btn btn-link p-0 flex-shrink-0"
              style={{ color: "#e6ecf1", textDecoration: "none" }}
            >
              <img src="/icons/arrow-left.svg" alt="Back" />
            </button>
            <h1 className="text-heading-h2 m-0" style={{ color: "#e6ecf1" }}>
              {moduleData.title}
            </h1>
          </div>
          {/* Spacer for balance */}
          <div className="course-view-container">
            <div className="courses-modules-container">
              <h1
                className="text-heading-h3 mb-0"
                style={{ color: "var(--Text-100, #d0d8df)" }}
              >
                Chapters
              </h1>
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              ) : (
                <ul className="nav nav-tabs courses-view-custom-tabs">
                  {chapters.map((chapter, index) => {
                    const shouldTruncate = chapter.title.split(" ").length > 30;
                    const truncatedTitle = shouldTruncate
                      ? `${chapter.title.split(" ").slice(0, 30).join(" ")}...`
                      : chapter.title;

                    return (
                      <li className="nav-item" key={`nav-${index + 1}`}>
                        <a
                          href="/#"
                          className={`nav-link text-body-b3 ${
                            index === 0 ? "active" : ""
                          }`}
                          // data-bs-toggle={
                          //   index === 0 || videoCompletionStatus[index]
                          //     ? "tab"
                          //     : undefined
                          // }
                          data-bs-toggle={"tab"}
                          // aria-disabled={
                          //   index !== 0 && !videoCompletionStatus[index]
                          // }
                          onClick={(e) => {
                            // if (index !== 0 && !videoCompletionStatus[index]) {
                            //   e.preventDefault();
                            //   return;
                            // }
                            e.preventDefault();
                            if (activeChapter !== index + 1) {
                              setChapterLoading(true);
                              setActiveChapter(index + 1);
                              setTimeout(() => {
                                setChapterLoading(false);
                              }, 500);
                            }
                          }}
                          data-bs-target={`#chapter-${index + 1}`}
                        >
                          <div
                            className={`module-status ${
                              videoCompletionStatus[index + 1]
                                ? "completed-video"
                                : ""
                            }`}
                          >
                            {videoCompletionStatus[index + 1] && (
                              <img
                                alt="image-alt"
                                src="/icons/check-small.svg"
                              />
                            )}
                          </div>
                          <span
                            className="text-body-b3"
                            style={{ color: "var(--Text-200, #c8ced3)" }}
                          >
                            Chapter {index + 1}
                            <span
                              className="courses-link-chapter-detail"
                              title={shouldTruncate ? chapter.title : undefined}
                            >
                              {" "}
                              - {truncatedTitle}
                            </span>
                          </span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>

            <hr className="setting-vertical-line courses-hr" />

            <div className="tab-content setting-tab-content">
              {chapterLoading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              ) : (
                chapters.map(
                  (chapter, index) =>
                    activeChapter === index + 1 && (
                      <div
                        key={`content-${index + 1}`}
                        id={`chapter-${index + 1}`}
                        className="tab-pane fade show active"
                      >
                        <CoursesChapter
                          index={index + 1}
                          videoSrc={chapter.video_url || null}
                          moduleTitle={moduleData.title}
                          chapterNo={chapter.id}
                          chapterTitle={chapter.title}
                          vedioDescription={chapter.description}
                          videoCompleted={videoCompletionStatus[index + 1]}
                          onVideoComplete={() => handleVideoComplete(index + 1)}
                          onClickBtn={() => loadNextVideo(index + 1)}
                          moduleProgress={moduleData.completion_percentage}
                        />
                      </div>
                    ),
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
